import { render, staticRenderFns } from "./ResponseWordLimit.vue?vue&type=template&id=2d4e13d9&scoped=true"
import script from "./ResponseWordLimit.vue?vue&type=script&lang=js"
export * from "./ResponseWordLimit.vue?vue&type=script&lang=js"
import style0 from "./ResponseWordLimit.vue?vue&type=style&index=0&id=2d4e13d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4e13d9",
  null
  
)

export default component.exports